// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_layoutContainer__Xbqo1 {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.styles_footer__XUcq4 {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 28px 16px;
  font: var(--typography-body-s-regular);
  color: var(--color-text-secondary);
  gap: 4px;
  height: auto;
  flex-direction: column;
}
@media (min-width: 768px) {
  .styles_footer__XUcq4 {
    gap: 16px;
    flex-direction: row;
    padding: 20px 40px 28px 40px;
  }
}
@media (min-width: 1024px) {
  .styles_footer__XUcq4 {
    padding: 40px 100px;
  }
}

.styles_footerLinks__VmKEH {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
}
@media (min-width: 1024px) {
  .styles_footerLinks__VmKEH {
    gap: 80px;
  }
}

.styles_link__jf2iN {
  color: var(--color-text-secondary);
  text-decoration: none;
  font: var(--typography-body-s-regular);
  cursor: pointer;
}
.styles_link__jf2iN:hover {
  text-decoration: underline;
}

.styles_activeLink__fx0A0 {
  color: var(--color-accent-blue);
}`, "",{"version":3,"sources":["webpack://./src/components/footer/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,sCAAA;EACA,kCAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;AAAF;ACXE;EDCF;IAaI,SAAA;IACA,mBAAA;IACA,4BAAA;EACF;AACF;ACZE;EDLF;IAmBI,mBAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAEF;AC1BE;EDkBF;IASG,SAAA;EAGD;AACF;;AAAA;EACE,kCAAA;EACA,qBAAA;EACA,sCAAA;EACA,eAAA;AAGF;AADE;EACE,0BAAA;AAGJ;;AACA;EACE,+BAAA;AAEF","sourcesContent":["@import \"mixins\";\n.layoutContainer {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.footer {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 16px 28px 16px;\n  font: var(--typography-body-s-regular);\n  color: var(--color-text-secondary);\n  gap: 4px;\n  height: auto;\n  flex-direction: column;\n\n  @include md {\n    gap: 16px;\n    flex-direction: row;\n    padding: 20px 40px 28px 40px;\n  }\n\n  @include lg {\n    padding: 40px 100px;\n  }\n}\n\n.footerLinks {\n  display: flex;\n  cursor: pointer;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  padding: 12px 0;\n\n  @include lg {\n   gap: 80px;\n  }\n}\n\n.link {\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  font: var(--typography-body-s-regular);\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.activeLink {\n  color: var(--color-accent-blue);\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layoutContainer": `styles_layoutContainer__Xbqo1`,
	"footer": `styles_footer__XUcq4`,
	"footerLinks": `styles_footerLinks__VmKEH`,
	"link": `styles_link__jf2iN`,
	"activeLink": `styles_activeLink__fx0A0`
};
export default ___CSS_LOADER_EXPORT___;
